import { render, staticRenderFns } from "./PosicaoNotaFiscalFilterBar.vue?vue&type=template&id=4af2dd1e"
import script from "./PosicaoNotaFiscalFilterBar.vue?vue&type=script&lang=js"
export * from "./PosicaoNotaFiscalFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports